var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ringValText_item"},[_c('span',{staticClass:"ringValText_bg",style:({
      width: `calc(${_vm.widthVw}vw * ${_vm.cssDynamicObj.mixvw})`,
      height: `calc(${_vm.widthVw}vw * ${_vm.cssDynamicObj.mixvw})`,
      '--mixtmt_mixvw': _vm.cssDynamicObj.mixvw,
    })},[_c('span',{staticClass:"ringValTextItem_abs",class:_vm.val[0] && _vm.val[0].length > 2 ? '' : 'bigFontSize',domProps:{"textContent":_vm._s(_vm.val[0])}})]),_c('span',{staticClass:"ringValText_name",domProps:{"textContent":_vm._s(_vm.val[1])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }